export const environment = {
    API_URL: 'https://api.evngenco1.vn',
    // API_URL: 'https://apigenco1.viecvv.com',
    siteKeyV3: '6LdElDIqAAAAAK6XTRESRdEnGU2yqhkOJTvrUtDd'
};
